import { Dialog, styled } from '@mui/material';
import { colors } from '@watter/shared-components';

export const NoInternetModalUI = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        zIndex: 0,
    },
    '&.changePassword': {
        '& .MuiDialog-paper': {
            padding: theme.spacing(2),

            alignItems: 'center',

            '& .MuiDialogActions-root': {
                padding: theme.spacing(3),
                paddingTop: 0,
                [theme.breakpoints.down('sm')]: {
                    flexDirection: 'column',
                },
            },
        },
    },
    '& .cstBtnWrapper': {
        '& .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.2),
            margin: '10px 10px',

            '& .cstBtn': {
                width: '200px',

                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
            },
            '& .cstBtn2': {
                width: '200px',
                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
                border: '1px solid var(--Color-tokens-Strokes-Neutral-Dark, #47474B)',
            },
            '&:active': {
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                borderRadius: theme.spacing(4),
            },

            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: -1,
                inset: 0,
                borderRadius: theme.spacing(4),
            },
        },
    },
}));
